import { createFileRoute } from "@tanstack/react-router";

import { OnboardingCycle } from "../../../features/onboarding/OnboardingCycle";

export const Route = createFileRoute("/_app/onboarding/cycle")({
  component: OnboardingCycle,
});
